import ScoreParecerInteligenteI18n from '../../components/fin-bank-credit-score/subcomponents/score-dashboard/subcomponents/score-parecer-inteligente/i18n/ScoreParecerInteligenteI18n_es-es';
import FinBankCreditScoreDashboardI18n from '../../components/fin-bank-credit-score/subcomponents/score-dashboard/i18n/FinBankCreditScoreDashboardI18n_es-es';
import FinBankCreditScoreResultI18n from '../../components/fin-bank-credit-score/subcomponents/score-dashboard/subcomponents/score-result/i18n/FinBankCreditScoreResultI18n_es-es';
import FinBankCreditScoreInfoI18n from '../../components/fin-bank-credit-score/subcomponents/score-dashboard/subcomponents/score-info/i18n/FinBankCreditScoreInfoI18n_es-es';
import FintechNotHiredI18n from '../../components/fintech-not-hired/i18n/FintechNotHiredI18n_es-es';
import commonI18n from '../common/es-es';

export default {
  translation: {
    common: commonI18n,
    FinBankCreditScoreDashboard: FinBankCreditScoreDashboardI18n,
    FinBankCreditScoreResult: FinBankCreditScoreResultI18n,
    FinBankCreditScoreInfo: FinBankCreditScoreInfoI18n,
    FintechNotHired: FintechNotHiredI18n,
    ScoreParecerInteligente: ScoreParecerInteligenteI18n,
  },
};
